export default __webpack_public_path__ + "static/media/dos_nu.72657880.jpg";